import { Fragment } from 'react';

export default function MainText() {
  return (<Fragment>
    <h2>I'm Jesse Youngmann.</h2>
    <p>I'm a full-stack web developer.</p>
    <p>I have experience in Rails, React, Postgres, Ansible, and a bunch of other web development tools.</p>
    <p>I've really enjoyed using Rust for personal projects.</p>
    <p>
      You can find my <a href='https://linkedin.com/in/jesse-youngmann'>resume at linkedin</a> and
      <a href='https://github.com/jesseyoungmann'> some public code at github</a>.
    </p>

    <h2>There's not much here.</h2>
    <p>This site is mostly for testing webdev tools.</p>
    <p>I made it with React for the frontend, and a Rust backend in Actix, which is great and entirely overkill for a personal site.</p>
    <p>
      I automated provisioning and compiling and deploying it to a DigitalOcean droplet with Docker, Webpack, and Ansible.
      (I'm not actually deploying a docker container, just cross compiling it for linux with docker.)
    </p>
    <p>It's being served by nginx and Actix.</p>
    <p>It's got HTTPS using Let's Encrypt and certbot.</p>
    <p>My <a href="/blog">blog</a> is separately generated by Zola (the static site generator, not the wedding planning platform).</p>
  </Fragment>);
}
